<div class="gps-logs"
     *ngIf="gpsLogDateGroups">
    <table data-cy="search-result-table" class="table">
        <thead>
            <tr>
                <th data-cy="unit">Unit</th>
                <th data-cy="time">Time</th>
                <th data-cy="distance" class="hidden-xs">Distance</th>
                <th data-cy="speed" class="hidden-xs">Speed</th>
                <th data-cy="device" class="hidden-xs">Device</th>
                <th data-cy="actions" width="3%">Actions</th>
            </tr>
        </thead>
        <tbody>
            <ng-container *ngFor="let dateGroup of gpsLogDateGroups">
                <tr>
                    <th data-cy="date-group"
                        class="active"
                        colspan="8">{{ dateGroup.date | appDateFromConfig: 'dateFormatLong' }}
                    </th>
                </tr>
                <ng-container *ngFor="let deviceGroup of dateGroup.devices;">
                    <tr *ngFor="let log of deviceGroup.items">
                        <td>
                            <span data-cy="truck-log" *ngIf="log.truckNumber">{{ log.truckNumber }} - {{ businessCaption(log.business) }}</span>
                            <span *ngIf="!log.truckNumber"></span>
                        </td>
                        <td class="nowrap">
                            <span data-cy="log-time" title="{{ log.timestamp.format(fromConfig('momentTimeFormatLong')) | lowercase }}">
                                {{ dateService.momentToClosestMinute(log.timestamp).format(fromConfig('momentTimeFormatMedium')) |
                                   lowercase }}
                            </span>
                        </td>
                        <td data-cy="distance-from-center" class="hidden-xs nowrap">{{ log.distanceFromCenter | number: '1.0-0' }}m</td>
                        <td data-cy="log-speed" class="hidden-xs nowrap">{{ log.speed }}km/h</td>
                        <td data-cy="log-device-id" class="hidden-xs nowrap">{{ log.deviceId }}</td>
                        <td width="3%" class="nowrap">
                            <a [attr.data-cy]="'view-on-map-' + log.truckNumber"
                               *ngIf="log.truckNumber"
                               (click)="viewOnMap(log)">View on Map</a> &nbsp; | &nbsp;
                            <a [attr.data-cy]="'request-video-' + log.truckNumber"
                               *ngIf="log.truckNumber"
                               (click)="createRequest(log)">Request Video</a>

                            <span data-cy="log-unavailable" 
                                  *ngIf="!log.truckNumber"
                                  class="text-danger"
                                  title="Contact Service Desk">
                                <strong>Unavailable</strong>
                            </span>
                        </td>
                    </tr>
                </ng-container>
            </ng-container>
            <tr class="info">
                <th data-cy="log-text" 
                    class="text-center"
                    colspan="8">
                    Showing the best
                    {{ gpsLogsResponse.filteredResultsCount }}
                    results (from a total of
                    {{ gpsLogsResponse.fromTotalResultsCount }}
                    results) for today and the last
                    {{ gpsLogsResponse.forDaysInThePast }}
                    days (from a maximum of
                    {{ gpsLogsResponse.ofAllowedDaysInThePast }}
                    days).
                </th>
            </tr>
        </tbody>
    </table>
</div>
